var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { QueryClient } from 'react-query';
import { CacheKeys } from '../constants';
let instance = null;
export const initQueryClient = () => {
    instance = new QueryClient({
        defaultOptions: {
            queries: {
                refetchOnWindowFocus: true,
                retry: false
            }
        }
    });
    return instance;
};
export const getQueryClient = () => instance;
export const normalizeContactDoc = (contact) => {
    const client = getQueryClient();
    const statuses = ['active', 'blocked', 'archived'];
    statuses.forEach((status) => {
        client.setQueryData([CacheKeys.CONVERSATIONS, status], (cur) => {
            if (!cur)
                return cur;
            cur.pages = cur.pages.map((page) => ({
                records: page.records.map((curContact) => {
                    return curContact.id === contact.id ? contact : curContact;
                })
            }));
            return cur;
        });
    });
};
export const loadNewMessage = (message, isPrivate) => {
    const client = getQueryClient();
    client.setQueryData([CacheKeys.MESSAGES, message.thread, isPrivate], (cur) => {
        var _a;
        if (!cur)
            return cur;
        cur.pages[0] = [message, ...((_a = cur.pages[0]) !== null && _a !== void 0 ? _a : [])];
        return cur;
    });
};
const insertContactAtTop = (newDoc) => {
    const client = getQueryClient();
    const statuses = ['active', 'blocked', 'archived'];
    statuses.forEach((status) => {
        client.setQueryData([CacheKeys.CONVERSATIONS, status], (cur) => {
            var _a;
            if (!cur)
                return cur;
            cur.pages = cur.pages.map((page) => page.filter((curContact) => {
                return curContact.id !== newDoc.id;
            }));
            cur.pages[0] = [newDoc, ...((_a = cur.pages[0]) !== null && _a !== void 0 ? _a : [])];
            return cur;
        });
    });
};
export const updateContactAndConversation = (newDoc) => {
    insertContactAtTop(newDoc);
    updateConversation(newDoc);
};
export const updateLastSeen = (participant, online, lastSeen) => {
    const client = getQueryClient();
    client.setQueriesData([CacheKeys.CONVERSATION], (cur) => {
        if (!cur)
            return cur;
        return Object.assign(Object.assign({}, cur), { participants: cur.participants.map((v) => (Object.assign(Object.assign({}, v), (v.id === participant ? { online, lastSeen } : {})))) });
    });
    client.setQueriesData([CacheKeys.CONVERSATIONS], (cur) => {
        if (!cur)
            return cur;
        cur.pages = cur.pages.map((page) => page.map((contact) => {
            return Object.assign(Object.assign({}, contact), { participants: contact.participants.map((v) => (Object.assign(Object.assign({}, v), (v.id === participant ? { online, lastSeen } : {})))) });
        }));
        return cur;
    });
};
export const updateConversation = (newDoc) => {
    const client = getQueryClient();
    client.setQueryData([CacheKeys.CONVERSATION, newDoc.id], (cur) => {
        if (!cur)
            return cur;
        return newDoc;
    });
};
export const refetchRecs = () => __awaiter(void 0, void 0, void 0, function* () {
    const client = getQueryClient();
    yield client.refetchQueries(CacheKeys.RECOMMENDATIONS);
});
//# sourceMappingURL=react-query.js.map